export enum SharedOption {
  Yes = 'Yes',
  No = 'No',
  NotApplicable = 'NotApplicable'
}
